import BackofficeLayout from '@/components/layouts/BackofficeLayout'

import { useState, useEffect } from 'react'
import { useAxiosApi } from '@/hooks/useAxiosApi'
import useMe from '@/hooks/useMe'

// UI
import FulfillmentOrderDisplay from '@/components/fulfillment_orders/FulfillmentOrderDisplay'

import ActivityLog from '@/components/ui/ActivityLog'
import FulfillmentOrderCreateEdit from '@/components/fulfillment_orders/FulfillmentOrderCreateEdit'
import FulfillmentOrderClose from '@/components/fulfillment_orders/FulfillmentOrderClose'

import ScrollableScreen from '@/components/ui/ScrollableScreen'
import NotFound from '@/components/ui/NotFound'

// Mantine
import { Button } from '@mantine/core'

// Router
import { useParams } from 'react-router-dom'

// User
export default function FulfillmentOrder() {
    // Router

    const { fulfillment_order_id } = useParams()

    // User
    const { isAdmin } = useMe()

    // State
    const [fulfillmentOrder, setFulfillmentOrder] = useState(null)
    const [editMode, setEditMode] = useState(false)

    // Load fulfillment order
    const { requestGet, requestPost } = useAxiosApi()

    const loadComponent = async () => {
        const { data } = await requestGet(
            `/fulfillment-orders/${fulfillment_order_id}`
        )

        setFulfillmentOrder(data)
    }

    useEffect(() => {
        if (fulfillment_order_id) {
            loadComponent()
        }
    }, [fulfillment_order_id])

    // Save edit. One call: the API writes the order, replaces its lines and
    // drops the parcels already generated in a single transaction.
    const saveEdit = async ({ fulfillmentOrderFormValue, linesFormValue }) => {
        await requestPost(
            `/fulfillment-orders/${fulfillment_order_id}/edit`,
            {
                fulfillment_order: fulfillmentOrderFormValue,
                lines: linesFormValue,
            }
        )

        // Reload component
        await loadComponent()

        // Close edit mode
        setEditMode(false)
    }

    if (fulfillmentOrder?.id && !isAdmin && fulfillmentOrder?.location_id !== 1) {
        return <NotFound />
    }

    // Header
    const RightSection = (
        <div className="flex items-center gap-5">
            {fulfillmentOrder?.id && (
                <ActivityLog
                    subjectType="fulfillment-orders"
                    subjectId={fulfillmentOrder.id}
                />
            )}

            {isAdmin &&
                fulfillmentOrder &&
                !fulfillmentOrder.shopify_id &&
                !fulfillmentOrder.retailer_estimate_id &&
                !editMode && (
                    <div className="flex items-center gap-3">
                        <FulfillmentOrderClose
                            fulfillment_order={fulfillmentOrder}
                            reload={loadComponent}
                        />
                    </div>
                )}

            {fulfillmentOrder && !fulfillmentOrder.shopify_id && editMode && (
                <div className="flex gap-2">
                    <Button
                        variant="default"
                        onClick={() => setEditMode(false)}
                    >
                        Annuler les modifications
                    </Button>
                </div>
            )}
        </div>
    )

    // Breadcrumbs
    const breadcrumbs = [
        {
            label: 'Demandes de préparation',
            href: '/fulfillment_orders',
        },
        {
            label: 'BP' + fulfillment_order_id,
        },
    ]

    return (
        <ScrollableScreen
            breadcrumbs={breadcrumbs}
            rightSection={RightSection}
            commentableType="fulfillment_order"
            commentableId={fulfillment_order_id}
        >
            <div className="@container p-5 flex flex-col w-full">
                {fulfillmentOrder && !editMode && (
                    <FulfillmentOrderDisplay
                        fulfillment_order={fulfillmentOrder}
                        loadComponent={loadComponent}
                    />
                )}

                {fulfillmentOrder && editMode && (
                    <FulfillmentOrderCreateEdit
                        fulfillment_order={fulfillmentOrder}
                        onSubmit={saveEdit}
                    />
                )}
            </div>
        </ScrollableScreen>
    )
}
